import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proposed-discount-list',
  templateUrl: './proposed-discount-list.component.html',
  styleUrls: ['./proposed-discount-list.component.css']
})
export class ProposedDiscountListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/lead/proposed-discount-list/proposed-discount-list.component.ts